exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mGN64_OvoSmKRQY--_UiY {\n  color: #fff;\n  background-color: #5391E4;\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  cursor: pointer;\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n  .mGN64_OvoSmKRQY--_UiY._4zCt6pBbx9c1S2Pvd7iTC {\n    background-color: #ccc; }\n", ""]);

// exports
exports.locals = {
	"code": "mGN64_OvoSmKRQY--_UiY",
	"disabled": "_4zCt6pBbx9c1S2Pvd7iTC"
};